<template>

	<div>
		<virtualAccountComponent 		 v-if="pmsPaymentPermission && $global.user_vr_corp == 'YES'" 						:paymentType="'pms_membership_payment'" @optVerified="recordPayment"		></virtualAccountComponent>
		<fincaComponent  			v-else-if="pmsPaymentPermission && $global.user_company_payment_engine == 'FINCA'"  	:paymentType="'pms_membership_payment'" @corpLoginSuccess="recordPayment"	></fincaComponent>
		<meezanComponent 			v-else-if="pmsPaymentPermission && $global.user_company_payment_engine == 'MEEZAN'" 	:paymentType="'pms_membership_payment'" @corpLoginSuccess="recordPayment"	></meezanComponent>
		<faysalComponent 			v-else-if="pmsPaymentPermission && $global.user_company_payment_engine == 'FAYSAL'" 	:paymentType="'pms_membership_payment'" @corpLoginSuccess="recordPayment"	></faysalComponent>
		<easypaisaComponent 		v-else-if="pmsPaymentPermission && $global.user_company_payment_engine == 'EASY_PAISA'" :paymentType="'pms_membership_payment'" @corpLoginSuccess="recordPayment"	></easypaisaComponent>

		<div class="bg-white rozee-performance-main">
			<div class="bg-dark border-bottom1">
				<nav class="navbar navbar-expand-lg container">
					<div class=" mx-auto text-center">
						<ul class="navbar-nav  ">
							<li class="nav-item active">
								<a class="nav-link text-white font-16 pl-md-5" href="#">Features</a>
							</li>
							<li class="nav-item">
								<a class="nav-link text-white font-16 pl-md-5" href="#">Process</a>
							</li>
							<li class="nav-item">
								<a class="nav-link text-white font-16 pl-md-5" href="#">Pricing</a>
							</li>
						</ul>
					</div>
				</nav>
			</div>
			<section class="text-center pt-5" style="position: relative;">
				<div class="top-dark-bg bg-dark bg-overlay fixed-height"></div>
				<div class="container" style="position: relative;z-index: 2;">
					<div class="text-space  text-primary">FINJA INTRODUCES</div>
					<div class="text-white font-weight-bold font-40 pb-2">Performance Management System</div>
					<div class="  font-20 text-seconday1 pb-4">Develop a culture of high performance, recognition, coaching and
					<br> wellbeing of your workforce with Finja.</div>
					<div class="pb-3"><a class="btn-primary b-radius-22 d-inline-block px-5 py-3 font-18" href="#demo">Get Started!</a></div>
					<div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
						<div class="carousel-inner">
						<div class="carousel-item active">
							<img class="d-block img-fluid w-100" src="/images/banner-image1.png" alt="First slide">
						</div>
							<div class="carousel-item">
							<img class="d-block img-fluid w-100" src="/images/banner-image2.png" alt="Second slide">
						</div>
						<div class="carousel-item">
							<img class="d-block img-fluid w-100" src="/images/banner-image3.png" alt="Third slide">
						</div>
						</div>
						<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"  style="    margin-right: 130px; margin-bottom: 30px;"></span>
						<span class="sr-only">Previous</span>
						</a>
						<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true" style="    margin-left: 130px; margin-bottom: 30px;"></span>
						<span class="sr-only">Next</span>
						</a>
					</div> 
					<div class="pt-50 text-black font-weight-bold font-40 pb-2">Features</div>
					<div class="row">
						<div class="col-md-4 mt-4">
							<div class="circle mb-3"><i class="rz-shape font-30" style="line-height: 50px;"></i></div>
							<div class="  font-14 text-seconday1 pb-4">User defined setups including Rating <br> Scale, Appraisal Cycle, Review Sets,<br> Goals and Competencies. </div>
						</div>
						<div class="col-md-4 mt-4">
							<div class="circle mb-3"><i class="rz-shape2 font-30" style="line-height: 50px;"></i></div>
							<div class="  font-14 text-seconday1 pb-4">Goals & KPIs Creation,<br> Cascading and Acknowledgment.</div>
						</div>
						<div class="col-md-4 mt-4">
							<div class="circle mb-3"><i class="rz-shape3 font-30" style="line-height: 50px;"></i></div>
							<div class="  font-14 text-seconday1 pb-4">Self and Reporting Manager’s<br> Evaluation of Assigned Goals & KPIs.</div>
						</div>
						<div class="col-md-4 mt-4">
							<div class="circle mb-3"><i class="rz-shape4 font-30" style="line-height: 50px;"></i></div>
							<div class="  font-14 text-seconday1 pb-4">360 Degrees Technical and Behavioral<br> Competencies Surveys.</div>
						</div>
						<div class="col-md-4 mt-4">
							<div class="circle mb-3"><i class="rz-shape5 font-30" style="line-height: 50px;"></i></div>
							<div class="  font-14 text-seconday1 pb-4">Performance Infographics on HR,<br> Reporting Manager and ESS Users<br> Screens.</div>
						</div>
						<div class="col-md-4 mt-4">
							<div class="circle mb-3"><i class="rz-shape6 font-24" style="line-height: 50px;"></i></div>
							<div class="  font-14 text-seconday1 pb-4">System Calculated Performance<br> Scores and Ranks.</div>
						</div>
					</div>
				</div>
				<div class="pb-50 mt-50 " style="background-color:#fafafa ">
					<div class="container">
						<div class="pt-50 text-black font-weight-bold font-40 pb-2">Process</div>
						<div class="row">
							<div class="col-md-3 mt-4">
								<div class="circle1 position-relative  mb-3">
									<span class=" text-white font-30" style="line-height: 75px;" >1</span>
								</div>
								<div class="  font-14 text-seconday1 pb-4">Reporting Manager creates Goals, KPIs under each Goal and assigns them to the respective team.</div>
							</div>
							<div class="col-md-3 mt-4">
								<div class="circle1 text-white font-30" style="line-height: 75px;">2</div>
								<div class="  font-14 text-seconday1 pb-4">
									Employee fills, updates the assigned goals status throughout review period and submits them back to the Reporting Manager.</div>
							</div>
							<div class="col-md-3 mt-4">
								<div class="circle1 text-white font-30" style="line-height: 75px;">3</div>
								<div class="  font-14 text-seconday1 pb-4"> HR shares the 360 degree Competencies Survey across the organization, employees fill and submit them back to HR.</div>
							</div>
							<div class="col-md-3 mt-4">
								<div class="circle1 text-white font-30" style="line-height: 75px;">4</div>
								<div class="  font-14 text-seconday1 pb-4">HR gets the final total score of Goals and Competencies of each employee based on which relevant decisions are taken.</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pb-50 mt-50 ">
					<div class="container">
						<div class=" text-black font-weight-bold font-40 pb-2">Pricing</div>
						<div class="d-md-flex mt-4">
							<div class="text-left flex-fill d-none d-md-block  border-right border-top-transparent">
								<div class="fixed-head-height font-26 font-weight-bold border-bottom border-top-first"> Features</div>
								<div class="fixed-child-height font-16 font-weight-bold  border-bottom">Number of Employees</div>
								<div class="fixed-child-height font-16 font-weight-bold  border-bottom">Startup Fee</div>
								<div class="fixed-child-height font-16 font-weight-bold  border-bottom">Price Per Emp/Month (PKR)</div>
								<div class="fixed-child-height font-16 font-weight-bold  border-bottom">Hosting and Support</div>
								<div class="fixed-child-height1 font-16 font-weight-bold ">Contract Period <br> <span class="font-weight-normal">Minimum 1 Appraisal Cycle<br>(12 Months)</span></div>
							</div>
							<div class="flex-fill border-right border-top border-bottom">
								<div class="fixed-head-height font-26 font-weight-bold border-bottom line-height-fixed pt-20"><a name='demo'>Free Trial</a></div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Number of Employees</div>Limited</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Startup Fee</div>-</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Price Per Emp/Month (PKR)</div>-</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Hosting and Support</div>-</div>
								<div class="fixed-child-height1 w-100 p-4">
									<button class=" btn-secondary b-radius-4 d-inline-block w-100 py-3 font-14" @click="selectPackage('FREE')" >START NOW</button>
								</div>
							</div>
							<div class="flex-fill border-right border-top border-bottom">
								<div class="fixed-head-height font-26 font-weight-bold border-bottom line-height-fixed pt-20">Startup </div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Number of Employees</div>25-50</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Startup Fee</div>PKR 15,000</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Price Per Emp/Month (PKR)</div>PKR 299</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Hosting and Support</div>free</div> 
								<div class="fixed-child-height1 w-100 p-4">
									<button class=" btn-secondary b-radius-4 d-inline-block w-100 py-3 font-14" @click="selectPackage('STARTUP')" >Buy Now</button>
								</div>
							</div>
							<div class="flex-fill border-right border-top border-bottom">
								<div class="fixed-head-height font-26 font-weight-bold border-bottom line-height-fixed pt-20"> Growing</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Number of Employees</div>51-200</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Startup Fee</div>PKR 25,000</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Price Per Emp/Month (PKR)</div>PKR 149</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Hosting and Support</div>free</div> 
								<div class="fixed-child-height1 p-4">
									<button class=" btn-secondary py-3 b-radius-4 d-inline-block w-100 font-14"  @click="selectPackage('GROWING')" >Buy Now</button>
								</div>
							</div>
							<div class="flex-fill border-right border-top border-bottom active">
								<div class="fixed-head-height font-26 font-weight-bold border-bottom line-height-fixed pt-20">  Corporate</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Number of Employees</div>201+</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Startup Fee</div>PKR 35,000</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Price Per Emp/Month (PKR)</div>PKR 99</div>
								<div class="fixed-child-height font-16 font-weight-bold border-bottom">
									<div class="d-md-none font-weight-normal">Hosting and Support</div>free</div> 
								<div class="fixed-child-height1 w-100 pb-5 pr-4 pl-4 pt-4">
									<button class="btn-primary b-radius-4 d-inline-block w-100 py-3 font-14" @click="selectPackage('CORPORATE')" >Buy Now</button>
								</div>
							</div>
						</div>  
					</div>
				</div>
				<div style="" class="text-center mt-50 font-16 pt-4 pb-4 border-bottom border-top">
					Copyright © 2020 Finja Business - All Rights Reserved
				</div>
			</section>
		</div>

		<!-- Payment Confirmation Modal -->
		<div class="modal fade" id="payment_confirmation_popup" tabindex="-1" role="dialog" aria-labelledby="payment_confirmation_popup" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content" >
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
						<span>×</span>
					</button>
					<div class="modal-body collections-settlement-popup p-4">
						<h2 class="mt-4 mb-3"> Are you sure that you want to Buy this package for  PKR {{ formatAmount(this.pmsPackagePrice) }}/-</h2>
						<div class="form-group align-center">
							<button class="btn btn-primary confirmation-btns active" @click="proceedWithLogin"> Yes</button>
							<button class="btn btn-primary confirmation-btns" @click="hideConfirmationPopup"> No</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>

import virtualAccountComponent from '../../modals/virtualAccountComponent';
import fincaComponent from '../../modals/fincaComponent';
import meezanComponent from '../../modals/meezanComponent';
import nbpFundsComponent from '../../modals/nbpFundsComponent';
import easypaisaComponent from '../../modals/easypaisaComponent';
import faysalComponent from '../../modals/faysalComponent';

export default {
	components: {
		virtualAccountComponent,
		fincaComponent,
		meezanComponent,
		nbpFundsComponent,
		easypaisaComponent,
		faysalComponent,
	},
	props: ['pmsPaymentPermission'],
	data() {
		return {
			employeesCount : 0,
			pmsSubscriptionsCount : 0,
			pmsPackage : 'FREE',
			pmsPackagePrice : 0,
		};
	},
	mounted() 
	{
		this.getCompanyDetails();
	},
	methods: {

		getCompanyDetails: function()
		{
			axios.get('/api/pms/getCompanyDetails')
			.then((res) => {
				if(res.data.status == 200)
				{
					console.log(res.data.data);

					this.employeesCount = res.data.data.employee_counts;
					this.pmsSubscriptionsCount = res.data.data.pms_subscriptions_count;
					this.$Progress.finish();
				}
				else
				{
					console.log(res.data);

					this.$Progress.finish();
					this.showAlertBox('error', 'Error', 'Unable To Get Company Details !');
				}
			})
			.catch((err) => {
				console.log(err);
				
				this.$Progress.finish();
				this.showAlertBox('error', 'Error', 'Unable To Get Company Details !!');
			});
		},
		
		selectPackage : function (packageName)
		{
			if(this.pmsPaymentPermission)
			{
				this.pmsPackage = packageName;
				this.pmsPackagePrice = this.getPackageDetails(packageName);

				if(this.pmsPackagePrice !== false)
				{
					$("#payment_confirmation_popup").modal('show');
				}
			}
			else
			{
				this.showAlertBox('error', 'Error', `Permission for PMS payment is not assinged`);
			}
		},

		hideConfirmationPopup : function (packageName)
		{
			$("#payment_confirmation_popup").modal('hide');
		},
		
		proceedWithLogin : function (packageName)
		{
			this.hideConfirmationPopup();

			//remove login screen when package is free
			if(this.pmsPackage === 'FREE') {
				let bank;
				if(this.$global.user_vr_corp == 'YES') {
					bank = 'virtual';

					this.recordPayment({
						bank: 'virtual',
						data: null
					});
				} else {
					// bank = $global.user_company_payment_engine;
					this.recordPayment({
						bank: this.$global.user_company_payment_engine,
						data: null
					});
				}

			} else {
				$('#loginMoblizer').modal('show');
			}
		},


		getPackageDetails : function(packageName)
		{
			let employeesCount = this.employeesCount;
			let pmsSubscriptionsCount = this.pmsSubscriptionsCount;

			let pmsPackagePrice = 0;
			let pmsPackageOneTimeCharges = 0;
			let pmsPackageExpInMonths = 0;
			let pmsPackageChargePerEmployee = 0;

			if(packageName === 'STARTUP')
			{
				if(employeesCount >= 1 && employeesCount <= 50)
				{
					if(pmsSubscriptionsCount > 0)
					{
						pmsPackageOneTimeCharges   = 0;
					}
					else
					{
						pmsPackageOneTimeCharges   = 15000;
					}

					pmsPackageExpInMonths          = 12;
					pmsPackageChargePerEmployee    = 299;

					pmsPackagePrice                = pmsPackageOneTimeCharges + (pmsPackageExpInMonths * pmsPackageChargePerEmployee * employeesCount);
				}
				else
				{
					this.showAlertBox('error', 'Error', `STARTUP Package cannot be selected for ${employeesCount} employees !`);
					return false;
				}
			}
			else if(packageName === 'GROWING')
			{
				if(employeesCount >= 51 && employeesCount <= 200)
				{
					if(pmsSubscriptionsCount > 0)
					{
						pmsPackageOneTimeCharges   = 0;
					}
					else
					{
						pmsPackageOneTimeCharges   = 25000;
					}
					

					pmsPackageExpInMonths          = 12;
					pmsPackageChargePerEmployee    = 149;
					pmsPackagePrice                = pmsPackageOneTimeCharges + (pmsPackageExpInMonths * pmsPackageChargePerEmployee * employeesCount);
				}
				else
				{
					this.showAlertBox('error', 'Error', `GROWING Package cannot be selected for ${employeesCount} employees !`);
					return false;
				}
			}
			else if(packageName === 'CORPORATE')
			{
				if(employeesCount >= 201)
				{

					if(pmsSubscriptionsCount > 0)
					{
						pmsPackageOneTimeCharges   = 0;
					}
					else
					{
						pmsPackageOneTimeCharges   = 35000;
					}

					pmsPackageExpInMonths          = 12;
					pmsPackageChargePerEmployee    = 99;
					pmsPackagePrice                = pmsPackageOneTimeCharges + (pmsPackageExpInMonths * pmsPackageChargePerEmployee * employeesCount);
				}
				else
				{
					this.showAlertBox('error', 'Error', `CORPORATE Package cannot be selected for ${employeesCount} employees !`);
					return false;
				}
			}
			else if(packageName === 'FREE')
			{
				pmsPackageOneTimeCharges       = 0;
				pmsPackageExpInMonths          = 1;
				pmsPackageChargePerEmployee    = 0;
				pmsPackagePrice                = pmsPackageOneTimeCharges + (pmsPackageExpInMonths * pmsPackageChargePerEmployee * employeesCount);
			}
			else
			{
				this.showAlertBox('error', 'Error', 'Package is not valid !');
				return false;
			}
			
			return pmsPackagePrice;
		},


		recordPayment : function(paymentData)
		{
			this.$Progress.start();

			let formData = {
				pmsPackage 	: this.pmsPackage,
				bank		: paymentData.bank,
				data 		: paymentData.data,
			};

			axios.post('/api/pms/recordPmsPayment', formData)
			.then((res) => {
				if(res.data.status == 200)
				{
					console.log(res.data);

					this.$emit('registerCompanyInPms');

					this.showToastBox('success', 'Suceess');
					this.$Progress.finish();
				}
				else
				{
					console.log(res.data);
					this.showAlertBox('error', 'Error', `Something Went Wrong ! ${res.data.msg} #13`);
					this.$Progress.finish();
				}
			})
			.catch((err) => {
				console.log(err);
				this.showAlertBox('error', 'Error', `Something Went Wrong ! #14`);
				this.$Progress.finish();
			});
		},
	},
};
</script>